import { StrictMode, useState } from 'react'
import ReactDOM from 'react-dom'
import * as Sentry from '@sentry/react'
import { moduleMetadataIntegration } from '@sentry/react'
import { MIXPANEL_API_KEY } from '@ucc/unified-admin-common'
import { Analytics } from '@ucc/unified-admin-common'
import mixpanel from 'mixpanel-browser'
import { importRemote } from 'module-federation-import-remote'
import { start } from 'single-spa'

import { App } from 'components'
import SplashScreen from 'components/shared/SplashScreen'
import config from 'config'
import { registerServicewoker } from 'service-workers/sw-registration'
import { beforeSend, transport } from 'utils/sentry/sentry-helper'

import '@ucc/unified-admin-common/output/index.css'
import 'css/index.css'

// @ts-ignore
mixpanel.init(MIXPANEL_API_KEY)
mixpanel.set_config({
  cross_subdomain_cookie: false,
  disable_persistence: true,
  ip: false,
})

Analytics.init({
  writeKey: config.SEGMENT_WRITE_KEY,
  environment: config.ENV,
})

Sentry.init({
  integrations: [moduleMetadataIntegration()],
  transport,
  beforeSend,
  dsn: config.sentryDsn,
  environment: config.ENV,
  enabled: config.SENTRY_ENABLED,
  release: config.version,
  maxBreadcrumbs: 20,
  ignoreErrors: [
    'TypeError: Cancelled',
    'TypeError: cancelled',
    'AbortError: The operation was aborted.',
    'SecurityError: The operation is insecure.',
    "TypeError: application '@ucc/unified-admin-jive' died in status LOADING_SOURCE_CODE: cancelled",
  ], // https://stackoverflow.com/questions/55738408/javascript-typeerror-cancelled-error-when-calling-fetch-on-ios
})

const splashScreenContainer = document.getElementById('splash-screen')
ReactDOM.render(<SplashScreen />, splashScreenContainer)

const AppWrapper = () => {
  const [isSubAppLoading] = useState(false)
  return <App loading={isSubAppLoading} />
}

ReactDOM.render(
  <StrictMode>
    <AppWrapper />
  </StrictMode>,
  document.getElementById('subapp-container'),
)

// Required to sync history browser routing between sub-apps
start({ urlRerouteOnly: true })

if (process.env.PRODUCTION_BUILD) {
  registerServicewoker()
}

importRemote({
  module: 'register',
  scope: config.subAppsModuleFederation.uccCCTopicFlags.scope,
  url: config.subAppsModuleFederation.uccCCTopicFlags.url.replace(/\/$/, ''),
}).then(
  ({ registerWebComponents }: any) => {
    registerWebComponents()
  },
  (error) => {
    Sentry.captureException(error)
  },
)
